import { render } from "./TPAHome.vue?vue&type=template&id=66fac7b7&scoped=true"
import script from "./TPAHome.vue?vue&type=script&lang=js"
export * from "./TPAHome.vue?vue&type=script&lang=js"

import "./TPAHome.vue?vue&type=style&index=0&id=66fac7b7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66fac7b7"]])

export default __exports__